import { Component, ViewChild, Input } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { EditPhotoComponent } from '../edit-photo/edit-photo.component';
import { PhotoUpload } from '../../../shared/modeles/photo-upload.modele';
import { Store } from '@ngxs/store';
import { ModifierPropriete, DeletePhoto } from '../../propriete.state';
import { GtmService } from '../../../shared/services/gtm.service';
import { GTM_PUSH_CATEGORY_INTERRACTIONS_PAGES, GTM_PUSH_CATEGORY } from '../../../shared/modeles/variables';
import { ProprieteModele } from '../../modeles/proprieteModel';
import { DownloadPhotoService } from '../../services/download-photo-service/download-photo.service';

@Component({
  selector: 'app-property-details-photo',
  templateUrl: './property-details-photo.component.html',
  styleUrls: ['./property-details-photo.component.scss'],
  standalone: false
})
export class PropertyDetailsPhotoComponent {
  @Input()
  set currentProperty(currentProperty: ProprieteModele) {
    this._currentProperty = currentProperty;
    if (this._currentProperty && this._currentProperty.photoId) {
      this.getPhotoUrl(this._currentProperty.photoId);
    }
  }

  @ViewChild(EditPhotoComponent)
  photoEditor: any;

  currentPhotoUrl: SafeUrl;

  private _currentProperty: ProprieteModele;

  constructor(
    private readonly _store: Store,
    private readonly _gtm: GtmService,
    private readonly _downloadPhotoService: DownloadPhotoService
  ) {}

  openFileBrowser() {
    this.photoEditor.openFileBrowser();
  }

  async deletePhoto() {
    await this._store.dispatch(new DeletePhoto(this._currentProperty)).toPromise();
    this._currentProperty.photoAbsoluteUrl = null;
    this.currentPhotoUrl = null;
    this._gtm.pushEvent({
      event: GTM_PUSH_CATEGORY_INTERRACTIONS_PAGES,
      category: GTM_PUSH_CATEGORY,
      label: 'paiement',
      action: 'supprimer photo',
      value: 0,
      nonInteraction: false
    });
  }

  async handlePhotoUpload(photoUpload: PhotoUpload) {
    const modifiedPropriete = {
      ...this._currentProperty,
      icone: null,
      photoId: photoUpload.idPhoto
    };
    const eventAction = this.currentPhotoUrl ? 'modifier photo' : 'ajouter photo';

    await this._store.dispatch(new ModifierPropriete(modifiedPropriete)).toPromise();

    this.getPhotoUrl(photoUpload.idPhoto);

    this._gtm.pushEvent({
      event: GTM_PUSH_CATEGORY_INTERRACTIONS_PAGES,
      category: GTM_PUSH_CATEGORY,
      label: 'paiement',
      action: eventAction,
      value: 0,
      nonInteraction: false
    });
  }

  getPhotoUrl(idPhoto: string): void {
    this._downloadPhotoService.getPhotoUrl(idPhoto).subscribe((photoUrl: SafeUrl) => {
      this.currentPhotoUrl = photoUrl;
    });
  }

  showElement(element: HTMLElement) {
    element.classList.add('visible');
  }

  hideElement(element: HTMLElement) {
    element.classList.remove('visible');
  }
}
